import {
  Box,
  forwardRef,
  BoxProps,
  useBreakpointValue,
} from "@chakra-ui/react";

export const Padding = forwardRef<BoxProps, "div">(({ ...props }, ref) => {
  const { children } = props;
  const boxPadding = useBreakpointValue({
    base: "104px 32px",
    lg: "104px",
  });
  return (
    <Box ref={ref} p={boxPadding} {...props}>
      {children}
    </Box>
  );
});
